module.exports = __webpack_public_path__ + "static/media/van-404-error.e0f831a8.png";